import {Grid} from "@material-ui/core";
import React, { useContext, useState } from "react";
import backgroundProvider from "../../assets/img/backgroundProvider.png";
import AccordionNav from "../../components/common/AccordionNav";
import ShowImage from "../../components/common/ShowImage";
import TextFieldMultiOutlined from "../../components/common/TextFieldMultiOutlined";
import TextFieldOutlined from "../../components/common/TextFieldOutlined";
import UserContext from "../../context/user-context";
import useInputUserChange from "../../hooks/useInputUserChange";
import useShowImage from "../../hooks/useShowImage";
import { useTranslation } from "../../hooks/useTranslation";
import useUploadImage from "../../hooks/useUploadImage";
import { fileNames } from "../../utils/imageUtil";
import { CompanionTabIndex, EntrantTabIndex } from "../../utils/tabIndex";

const Observations = () => {
  const { uploadNewPhoto } = useUploadImage();
  const { state } = useContext(UserContext);
  const getImage = useShowImage();
  const [observationsPhoto, setObservationsPhoto] = useState<any>(
    getImage(state.observationsPhoto)
  );
  const [observationsPhoto2, setObservationsPhoto2] = useState<any>(
    getImage(state.observationsPhoto2)
  );
  const [observationsPhoto3, setObservationsPhoto3] = useState<any>(
    getImage(state.observationsPhoto3)
  );
  const { t, BundleKey } = useTranslation();
  const { handleInputChange } = useInputUserChange();
  const isExiting = state.config?.eventType === "out";
  const [entryObservation] = useState(state.comment)
  const [exitObservation, setExitObservation] = useState('')


  const uploadNewImageObservationOnePhoto = (newPhoto: any) => {
    setObservationsPhoto(newPhoto);
    uploadNewPhoto(
      newPhoto,
      "observationsPhoto",
      fileNames.EVENT_OBSERVATION_PHOTO_FILENAME
    );
  };

  const uploadNewImageObservationTwoPhoto = (newPhoto: any) => {
    setObservationsPhoto2(newPhoto);
    uploadNewPhoto(
      newPhoto,
      "observationsPhoto2",
      fileNames.EVENT_OBSERVATION_PHOTO_2_FILENAME
    );
  };

  const uploadNewImageObservationThreePhoto = (newPhoto: any) => {
    setObservationsPhoto3(newPhoto);
    uploadNewPhoto(
      newPhoto,
      "observationsPhoto3",
      fileNames.EVENT_OBSERVATION_PHOTO_3_FILENAME
    );
  };

  return (
    <AccordionNav title={t(BundleKey.DETAIL_ENTRYMETHOD_OBSERVATION_TITLE)}>
      <Grid container spacing={3} direction="row">
        <Grid item xs={12} sm={6}>
          <Grid container direction="column" spacing={3}>
            <Grid item>
              <TextFieldOutlined
                  name="underagedCount"
                  value={state?.underagedCount?.toString()?.replace(/^0+/, "") || 0}
                  label={t(BundleKey.DETAIL_ENTRYMETHOD_OBSERVATION_CHILDREN)}
                  type="number"
                  onChange={(e) => {
                    const newValue = parseInt(e);
                    if (newValue >= 0) {
                      handleInputChange("underagedCount", newValue);
                    } else {
                      // If it's negative, you can choose to set it to 0 or take another action.
                      // For example, setting it to 0:
                      handleInputChange("underagedCount", 0);
                    }
                  }}
                  small
              />
            </Grid>
            <Grid item>
              {isExiting ? (
                  <TextFieldMultiOutlined
                      id="observationInput"
                      label={t(BundleKey.DETAIL_EXITMETHOD_OBSERVATION_DESCRIPTION)}
                      name="comment"
                      rows={4}
                      inputProps={{
                          tabIndex: state.config?.companion
                              ? CompanionTabIndex.observation
                              : EntrantTabIndex.observation,
                      }}
                      value={entryObservation}
                      onChange={() => null}
                  />
                ) : (
                  <TextFieldMultiOutlined
                      id="observationInput"
                      label={t(BundleKey.DETAIL_ENTRYMETHOD_OBSERVATION_DESCRIPTION)}
                      name="comment"
                      rows={4}
                      inputProps={{
                          tabIndex: state.config?.companion
                              ? CompanionTabIndex.observation
                              : EntrantTabIndex.observation,
                      }}
                      value={state.comment}
                      onChange={(value) => handleInputChange("comment", value)}
                  />
                )}
            </Grid>
            {isExiting && (
                <Grid item>
                  <TextFieldMultiOutlined
                      id="observationInput"
                      label={t(BundleKey.DETAIL_EXITMETHOD_OBSERVATION_EXCLUSIVE)}
                      name="comment"
                      rows={4}
                      inputProps={{
                          tabIndex: state.config?.companion
                              ? CompanionTabIndex.observation
                              : EntrantTabIndex.observation,
                      }}
                      value={exitObservation}
                      onChange={(value) => {
                        setExitObservation(value)
                        handleInputChange("comment", value)
                      }}
                  />
                </Grid>
            )}
            <Grid item>
              <TextFieldMultiOutlined
                  id="permanentInput"
                  label={t(BundleKey.DETAIL_ENTRYMETHOD_OBSERVATION_PERMANENT)}
                  name="permanent"
                  rows={4}
                  inputProps={{
                      tabIndex: state.config?.companion
                          ? CompanionTabIndex.observation
                          : EntrantTabIndex.observation,
                  }}
                  value={state.permanentComment}
                  onChange={(value) => handleInputChange("permanentComment", value)}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Grid container direction="column" spacing={3}>
            <Grid item>
              <ShowImage
                title={t(BundleKey.DETAIL_ENTRYMETHOD_OBSERVATION_PHOTO)}
                defaultImage={backgroundProvider}
                image={observationsPhoto}
                uploadNewPhoto={uploadNewImageObservationOnePhoto}
                alt="imageObservationOne"
              />
            </Grid>
            {observationsPhoto && (
              <Grid item>
                <ShowImage
                  title={t(BundleKey.DETAIL_ENTRYMETHOD_OBSERVATION_PHOTO) + " 2"}
                  defaultImage={backgroundProvider}
                  image={observationsPhoto2}
                  uploadNewPhoto={uploadNewImageObservationTwoPhoto}
                  alt="imageObservationTwo"
                />
              </Grid>
            )}
            {observationsPhoto2 && (
              <Grid item>
                <ShowImage
                  title={t(BundleKey.DETAIL_ENTRYMETHOD_OBSERVATION_PHOTO) + " 3"}
                  defaultImage={backgroundProvider}
                  image={observationsPhoto3}
                  uploadNewPhoto={uploadNewImageObservationThreePhoto}
                  alt="imageObservationThree"
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </AccordionNav>
  );
};

export default Observations;
